import React, {memo} from 'react';
import type {FieldProps} from 'formik';
import {FastField} from 'formik';
import {
	FormControl,
	FormLabel,
	Input,
	FormErrorMessage,
	FormHelperText,
} from '@tempo/core';
import {MIN_LEGAL_AGE} from '@app/modules/yup/constants';
import {useTranslation} from '@app/hooks/useTranslation';

const BirthdayField: React.FC = () => {
	const t = useTranslation();
	return (
		<FastField name="birthday">
			{({field, form}: FieldProps) => (
				<FormControl
					isInvalid={Boolean(form.errors.birthday && form.touched.birthday)}
				>
					<FormLabel htmlFor="birthday">{t('common.label_age')}</FormLabel>
					<Input
						{...field}
						data-testid="birthday-field"
						id="birthday"
						name="birthday"
						type="number"
					/>
					<FormErrorMessage data-testid="field-error-message">
						{form.errors.birthday as string}
					</FormErrorMessage>
					<FormHelperText>
						{t('formal.accountcreationagerestriction', {
							sprintf: [MIN_LEGAL_AGE],
							count: MIN_LEGAL_AGE,
						})}
					</FormHelperText>
				</FormControl>
			)}
		</FastField>
	);
};

export default memo(BirthdayField);
